<template>
  <div>
    <b-navbar variant="faded" type="dark" class="bg-dark" toggleable>
      <b-navbar-brand to="/" tag="h1" class="mb-0">
        <img
          src="./assets/logo.png"
          id="logo"
          class="d-inline-block align-top"
          width="20"
          height="20"
        >
        TimeAxis
      </b-navbar-brand>

      <b-navbar-nav>
        <router-link to="/about" class="nav-link">About</router-link>
      </b-navbar-nav>
      <b-navbar-nav>
        <router-link to="/records" class="nav-link">Records</router-link>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right v-if="isSignin">
          <!-- Using button-content slot -->
          <template slot="button-content">
            <em>{{ user.username }}</em>
          </template>
          <!-- <b-dropdown-item href="#">Profile</b-dropdown-item> -->
          <b-dropdown-item @click="onSignout">Signout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <!-- main -->
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Auth } from "aws-amplify";

export default {
  computed: {
    ...mapGetters(["isSignin", "user"])
  },
  methods: {
    onSignout: async function() {
      await Auth.signOut();
      this.$router.push({ path: "/" });
      this.$store.commit("setUser", null);
    }
  }
};
</script>

<style>
html {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
.navbar {
  background-color: f5f5f5;
}
.container {
  margin-top: 20px;
}
#logo {
  margin-top: 5px;
}
</style>
